import { action, computed, makeObservable, observable } from 'mobx'

import { getPhoneWithoutPrefix } from 'components/CountryPhoneInput/CountryPhoneInput'
import {
  ALL_EXCEPT_NUMBERS_REGEXP,
  EMAIL_REGEXP,
  NOT_LATIN_CYRILLIC_HYPHEN,
  TELEGRAM_REGEXP,
} from 'shared/constants/regExp'
import { Country } from 'shared/types/types'

import { countries } from '../../data'
import { AppCountryPhoneViewModel } from './AppCountryPhoneViewModel'

export class ProfileViewModel {
  @observable lastName: string = ''
  @observable firstName: string = ''
  @observable middleName: string = ''
  @observable snils: string = ''
  @observable telegramLogin: string = ''

  @observable additionalPhone: string = ''
  @observable additionalPhoneCountry: Country = Country.RU

  @observable mainPhone: string = ''
  @observable mainPhoneCountry: Country = Country.RU

  @observable additionalPhoneModel = new AppCountryPhoneViewModel()

  @observable email: string = ''

  constructor() {
    makeObservable(this)
  }

  @computed
  get isInvalidEmail() {
    return !EMAIL_REGEXP.test(this.email)
  }

  @computed
  get isInvalidFirstName() {
    return this.firstName?.trim().length < 2
  }

  @computed
  get isInvalidLastName() {
    return this.lastName?.trim().length < 2
  }

  @computed
  get isInvalidMiddleName() {
    return this.middleName ? this.middleName.trim().length < 2 : false
  }

  @computed
  get isInvalidTelegramLogin() {
    return !TELEGRAM_REGEXP.test(this.telegramLogin)
  }

  @action
  setEmail = (value: string) => {
    this.email = value
  }

  @action
  setLastName = (value: string) => {
    this.lastName = value.replace(NOT_LATIN_CYRILLIC_HYPHEN, '')
  }

  @action
  setFirstName = (value: string) => {
    this.firstName = value.replace(NOT_LATIN_CYRILLIC_HYPHEN, '')
  }

  @action
  setMiddleName = (value: string) => {
    this.middleName = value.replace(NOT_LATIN_CYRILLIC_HYPHEN, '')
  }

  @action
  setSnils = (value: string) => {
    this.snils = value?.replace(ALL_EXCEPT_NUMBERS_REGEXP, '')
  }

  @action
  setTelegramLogin = (value: string) => {
    this.telegramLogin = value
  }

  @action
  setAdditionPhone = (value: string) => {
    this.additionalPhone = value
  }

  @action
  setAdditionPhoneCountry = (value: Country) => {
    this.additionalPhoneCountry = value
  }

  @action
  initPhoneData() {
    const countryItemAdditionalPhone = countries.find((x) => x.value.country === this.additionalPhoneCountry)

    this.additionalPhoneModel.setSelectedCountry(countryItemAdditionalPhone?.value ?? countries[0].value)
    this.additionalPhoneModel.setPhone(
      getPhoneWithoutPrefix(
        countryItemAdditionalPhone?.value.country ?? countries[0].value.country,
        this.additionalPhone,
      ),
    )
  }
}
